
import { defineComponent } from "vue";
import { useRoute } from "vue-router";
import { IStudentsModel, IAcademicYearModel, ITuitionPriceLinesModel, ITuitionPriceListsModel, ITuitionDiscountsModel, IIndividualEnrollmentModel, ICourseGroupsModel, IHeadquartersModel, ICoursesModel } from "@/interfaces/modules/";
import StudenService from "@/api/Aula/StudentsService";
import AcademicYearService from "@/api/Configuration/AcademicYearService";
import CourseGroupsService from "@/api/Aula/CourseGroupsService";
import HeadquartersService from "@/api/Configuration/HeadquartersService";
import CoursesService from "@/api/Aula/CoursesSevice";
import IndividualEnrollmentService from "@/api/Enrollment/IndividualEnrollmentService";
import TuitionDiscountsService from "@/api/Collection/TuitionDiscountsService";
import TuitionPriceListsService from "@/api/Collection/TuitionPriceListsService";
import TuitionPriceLinesService from "@/api/Collection/TuitionPriceLinesService";
import store from "@/store";
import router from "@/router";
import { SHOW_PRESCHOOL } from "@/enums";
import EnrollmentChargeContent from "./EnrollmentChargeContent.vue";
import PaymentsContent from "./PaymentsContent.vue";
import EnrollmentAppliedDiscounts from "./EnrollmentAppliedDiscountsContent.vue";

export default defineComponent({
  name: "EnrollementIndividual",
  components: {
    EnrollmentChargeContent,
    PaymentsContent,
    EnrollmentAppliedDiscounts
  },
  data() {
    const route = useRoute();
    return {
      enrollmentId: route.params.Id || 0,
      disabledRecord: false,
      students: [] as IStudentsModel[],
      academicYears: [] as IAcademicYearModel[],
      coursesGroup: [] as ICourseGroupsModel[],
      coursesGroupAvailable: [] as ICourseGroupsModel[],
      headquarters: [] as IHeadquartersModel[],
      courses: [] as ICoursesModel[],
      priceLines: [] as ITuitionPriceLinesModel[],
      priceList: [] as ITuitionPriceListsModel[],
      discounts: [] as ITuitionDiscountsModel[],

      priceLineFiltered: [] as ITuitionPriceLinesModel[],
      priceListRecord: {} as ITuitionPriceListsModel,
      priceRecord: {} as ITuitionPriceLinesModel,
      discountRecord: {} as ITuitionDiscountsModel,
      studentRecord: {} as IStudentsModel,

      paymentError: "",

      form: {
        loading: true,
        dialog: false,
        valid: false,
        wasValidated: false,
        record: {} as IIndividualEnrollmentModel,
        rules: {
          required: [(v: any) => !!v || "Este campo es requerido"],
        },
      }
    };
  },
  watch: {
    'form.record.StudentId'(val: any) {
      this.form.wasValidated = !val || !this.form.record.StudentId;
    },
    'form.record.AcademicYearId'(val: any) {
      this.form.wasValidated = !val || !this.form.record.AcademicYearId;
    },
    'form.record.HeadquarterId'(val: any) {
      this.form.wasValidated = !val || !this.form.record.HeadquarterId;
      if (!val)
        this.form.record.CourseGroupId = 0 as any;
    },
    'form.record.CourseGroupId'(val: any) {
      this.form.wasValidated = !val || !this.form.record.CourseGroupId;
    },
    'form.record.MethodOfPayment'(val: string | undefined, oldVal: string | undefined) {
      // Never allow empty; if something tries to clear it, revert
      if (!val && oldVal) {
        this.$nextTick(() => (this.form.record.MethodOfPayment = oldVal));
      }
    }
  },
  computed: {
    formRecord(): any {
      return this.$refs.formRecord;
    },
  },
  async mounted() {
    await this.load();
    if (parseInt(this.enrollmentId as any) > 0) {
      this.disabledRecord = true;
      this.form.record = await IndividualEnrollmentService.GetEnrollmentById({ Id: this.enrollmentId });
      this.form.record.EnrollmentDate = this.form.record.EnrollmentDate.substring(0, 10);
      this.changeValuesLoad();
    }
    else {
      this.form.record = {
        Id: 0,
        StudentId: 0
      } as IIndividualEnrollmentModel
    }
  },
  methods: {
    async load() {
      this.form.loading = true;
      this.students = await StudenService.GetStudents();
      this.academicYears = await AcademicYearService.GetAcademicYears();
      this.coursesGroup = await CourseGroupsService.GetCourseGroups();
      this.headquarters = await HeadquartersService.GetHeadquarters();
      this.courses = await CoursesService.GetCourses(SHOW_PRESCHOOL.No);
      this.priceLines = await TuitionPriceLinesService.GetPriceLines();
      this.priceList = await TuitionPriceListsService.GetPriceLists();
      this.discounts = await TuitionDiscountsService.GetDiscounts();
      this.form.loading = false;
    },

    // ----- NAV HELPERS -----
    goTo(refName: 'tabStudent' | 'tabPayment' | 'tabConfirm') {
      const r: any = (this.$refs as any)[refName];
      const el: HTMLElement | undefined = r?.$el ? r.$el : r; // supports <b-button> or <button>
      if (el && typeof el.click === 'function') el.click();
    },

    // ----- VALIDATIONS -----
    validateStudentTab(): boolean {
      this.form.wasValidated = true;
      const r: any = this.form.record || {};
      const missing = [
        r.StudentId,
        r.AcademicYearId,
        r.HeadquarterId,
        r.CourseGroupId,
        r.EnrollmentDate,
        r.TuitionPriceLineId
      ].some(v => !v || v === 0 || v === '');
      return !missing;
    },

    validatePaymentMethod(): boolean {
      if (!this.form.record.MethodOfPayment) {
        this.paymentError = "Seleccione un método de pago.";
        return false;
      }
      this.paymentError = "";
      console.log('valid payment method');
      return true;
    },

    // ----- UI EVENTS -----
    setPayment(method: 'TRANSFERENCIA' | 'EFECTIVO') {
      if (this.form.record.MethodOfPayment === method) return; // do nothing on re-click
      this.form.record.MethodOfPayment = method;
      this.paymentError = "";
    },

    getPriceListById(id: any) {
      let _result = this.priceList.find(pl => pl.Id === id);
      return _result || ({} as ITuitionPriceListsModel);
    },

    async changeValuesLoad() {
      const yearId = this.form.record.AcademicYearId || 0 as any;
      const hqId = this.form.record.HeadquarterId || 0 as any;
      const studentId = this.form.record.StudentId || 0 as any;

      this.studentRecord = this.students.find(s => s.Id === studentId) || {} as IStudentsModel;

      if (!yearId || yearId <= 0 || !hqId || hqId <= 0) {
        this.coursesGroupAvailable = [];
        return;
      }

      const courseIdsAtHq = new Set(
        (this.courses || [])
          .filter(c => c.HeadquarterId === hqId)
          .map(c => c.Id)
      );

      this.coursesGroupAvailable = (this.coursesGroup || [])
        .filter(cg => cg.AcademicYearId === yearId && courseIdsAtHq.has(cg.CourseId))
        .sort((a, b) => (a.Name || '').localeCompare(b.Name || ''));

      const priceListsEnabled = (this.priceList ?? [])
        .filter(pl => !!pl.Enable && Number(pl.AcademicYearId) === yearId)
        .sort((a, b) => (a.Name || '').localeCompare(b.Name || ''));

      const enabledPriceListIds = new Set(priceListsEnabled.map(pl => pl.Id));

      const priceLinesEnabled = (this.priceLines ?? [])
        .filter(line => enabledPriceListIds.has(line.PriceListId))
        .sort((a, b) => (a.Concept || '').localeCompare(b.Concept || ''));

      this.priceLineFiltered = priceLinesEnabled;

      const selectedLineId = Number(this.form.record.TuitionPriceLineId ?? 0);
      const selectedLine = priceLinesEnabled.find(l => Number(l.Id) === selectedLineId);
      const selectedDiscountId = Number(this.form.record.DiscountId ?? 0);

      this.discountRecord = this.discounts.find(d => d.Id === selectedDiscountId) || {} as ITuitionDiscountsModel;

      if (selectedLine) {
        this.priceRecord = selectedLine;
        this.priceListRecord =
          priceListsEnabled.find(pl => pl.Id === selectedLine.PriceListId) ||
          {} as ITuitionPriceListsModel;
      } else {
        if (selectedLineId) this.form.record.TuitionPriceLineId = null as any;
        this.priceRecord = {} as ITuitionPriceLinesModel;
        this.priceListRecord = {} as ITuitionPriceListsModel;
      }
    },

    // Submit from first tab (Siguiente)
    async handleSubmit(e: Event) {
      e.preventDefault();
      // This submit comes from the first tab only
      if (this.validateStudentTab()) {
        this.goTo('tabPayment');
      }
    },

    handleNextFromPayment() {
      if (this.validatePaymentMethod()) {
        this.goTo('tabConfirm');
      }
    },

    // Registrar Admisión on last tab
    async registerAdmission() {
      if (!this.validateStudentTab()) {
        this.goTo('tabStudent');
        return;
      }
      if (!this.validatePaymentMethod()) {
        this.goTo('tabPayment');
        return;
      }

      try {
        this.form.loading = true;
        const res = await IndividualEnrollmentService.PostEnrollment(this.form.record);
        store.dispatch("core/popupDialog", {
          text: "Registro completado con éxito.",
          type: "success",
          showCancelButton: false,
        });
        this.form.loading = false;
        router.push(`/enrollment/enrollment-individual/${res.Id}`);
      } catch (err: any) {
        this.form.loading = false;
        store.dispatch("core/popupDialog", {
          text: `Error: ${err?.response?.data?.message || err?.message}`,
          type: "error",
          showCancelButton: false,
        });
      }


    },
  },
});
